import type { SVGProps } from 'react';
const SvgJusticeScale = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={20} height={20} fill="none" viewBox="-0.75 -0.75 20 20" {...props}>
    <desc>{'Justice Scale 1 Streamline Icon: https://streamlinehq.com'}</desc>
    <g stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5}>
      <path d="M7.929 12.801 4.295 4.625.66 12.801a3.76 3.76 0 0 0 1.064 2.628 3.6 3.6 0 0 0 2.57 1.089c.963 0 1.888-.392 2.57-1.089a3.76 3.76 0 0 0 1.064-2.628M7.929 12.801H.66M17.84 12.801l-3.635-8.176-3.634 8.176a3.76 3.76 0 0 0 1.065 2.628 3.6 3.6 0 0 0 2.57 1.089c.963 0 1.887-.392 2.569-1.089a3.76 3.76 0 0 0 1.064-2.628M17.84 12.801H10.57M1.982 4.625h14.536M9.25 4.625V1.982" />
    </g>
  </svg>
);
export default SvgJusticeScale;
